import {
  Box,
  Stack,
  styled,
  Typography,
  Button,
  useTheme,
  Grid,
  Divider,
  TextField,
} from "@mui/material";
import React from "react";
import Iconify from "../../iconify/iconify";
import { LayoutContainer } from "../container";
import ReferralBanner from "../../ReferralBanner";
import { useAuthStore } from "../../../stores/authStore";

const StyledAbstractStack = styled(Stack)(({ theme }) => ({
  position: "relative",
  padding: "80px 0 ",
  overflow: "hidden",
  zIndex: 1,
  ":before": {
    content: "url(/assets/AbstractDesign-Footer-Left.png)",
    position: "absolute",
    zIndex: 0,
    left: 0,
    bottom: 0,
  },
  ":after": {
    content: "url(/assets/AbstractDesign-Footer-Right.png)",
    position: "absolute",
    zIndex: 0,
    right: 0,
    bottom: 0,
  },
  [theme.breakpoints.down("sm")]: {
    padding: "50px 0 ",
    ":before": {
      top: "-80px",
    },
    ":after": {
      bottom: "-80px",
    },
  },
}));

const StyledEmailBox = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "5px",
  padding: "2px 11px 2px 0px",
  display: "flex",
  alignItems: "center",
  fieldset: {
    border: "none !important",
  },
}));

const StyledLinkTage = styled(Box)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textDecoration: "none",
  padding: "10px 3px",
  display: "inline-block",
  fontWeight: 500,
  fontFamily: '"Urbanist"',
}));

const StyledTargerLink = styled(Box)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textDecoration: "none",
  padding: "10px 3px",
  display: "inline-block",
}));
const AppFooter = () => {
  const theme = useTheme();
  const accessToken = useAuthStore((state) => state.auth.accessToken);

  return (
    <Stack bgcolor={theme.palette.background.default}>
      <Divider variant="fullWidth" orientation="horizontal" />
      {/* <StyledAbstractStack>
        <LayoutContainer>
          <Stack
            direction={{ xs: "column", md: "row" }}
            alignItems="center"
            justifyContent="space-between"
            gap={3}
            position="relative"
            zIndex={1}
          >
            <Stack direction="column" gap={2} width={{ xs: "100%", md: "60%" }}>
              <Typography variant="h3" color="text.secondary">
                ¿Listos Para Trabajar Juntos?
              </Typography>
              <Typography variant="subtitle1" color="text.secondary">
                En Plusvalica le damos a todos la oportunidad de participar a
                generar este gran ecosistema.
              </Typography>
              <Typography variant="subtitle1" color="text.secondary">
                ¿Quieres traer a nuestro portafolio oportunidades que crees
                únicas?
              </Typography>
            </Stack>
            <Stack textAlign="right" width={{ xs: "100%", md: "13%" }}>
              <Button
                variant="contained"
                href="/contactanos"
                sx={{
                  backgroundColor: "#a95052",
                  "&:hover": { backgroundColor: "#8c3e47" },
                }}
                fullWidth
              >
                ÚNETE A NOSOTROS!
              </Button>
            </Stack>
          </Stack>
        </LayoutContainer>
      </StyledAbstractStack> */}

      <Stack pt={{ xs: 5, md: 5 }} >
        <LayoutContainer>
          <Box
            display="flex"
            flexDirection={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            gap={1}
            pb={3}
            maxWidth={{ xs: "100%", md: "85%" }}
            m="auto"
          >
            <Box
              sx={{
                width: { xs: '100%', md: '55%' },
                display: 'flex',
                flexWrap: 'wrap',
                gap: 1,
              }}
            >
              {FooterLink.map((item, i) => (
                <Box 
                  key={i} 
                  sx={{ 
                    width: { xs: 'calc(33.33% - 8px)', md: 'calc(15% - 8px)' }, 
                    flexGrow: 1,
                  }}
                >
                  <Typography variant="subtitle1" color="grey" mb={2}>
                    {item.title}
                  </Typography>
                  <Box
                    component="ul"
                    sx={{
                      listStyle: "none",
                      margin: "0 !important",
                      padding: "0",
                    }}
                  >
                    {item?.child.map((child, j) => (
                      <Box component="li" key={j}>
                        <StyledLinkTage
                          component="a"
                          href={child.link}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {child.title}
                        </StyledLinkTage>
                      </Box>
                    ))}
                  </Box>
                </Box>
              ))}
            </Box>
            {!!accessToken && (
              <Box
                sx={{
                  width: { xs: '100%', md: '45%' },
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <ReferralBanner />
              </Box>
            )}
          </Box>
        </LayoutContainer>
        <Stack py={1}>
          <LayoutContainer>
            <Box component="a" href="/" >
              <Box
                component="img"
                src="/logoNuevo.png"
                width={{ xs: "330px", md: "330px" }}
                pb={7}
                pt={3}
                sx={{ display: 'block', mx: 'auto' }}
              />
            </Box>
            <Stack
              direction={{ xs: "column", md: "row" }}
              alignItems="center"
              justifyContent="space-between"
              maxWidth={{ xs: "100%", md: "85%" }}
              m="auto"
              pb={{ xs: 2, md: 6 }}
            >
              <Stack direction={{ xs: "column", md: "row" }} alignItems="center" gap={{ xs: 2, md: 6 }}>
                <Typography textAlign={{ xs: "center", md: "start" }} variant="subtitle1" color="text.secondary" maxWidth={350}>
                  Av. Hidalgo 2430, Vallarta Norte. CP. 44690. Guadalajarta, Jalisco
                </Typography>
                <Stack direction="column" alignItems="start">
                  <Typography variant="subtitle1" color="#a95052">
                    soporte@plusvalestate.com
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary">
                    +52 33 3547 7404
                  </Typography>
                </Stack>
              </Stack>
              

               <Stack direction="row" alignItems="center" gap={3}>
                <StyledTargerLink component="a" href="https://www.facebook.com/plusvalicaOficial">
                  <Iconify icon="mingcute:facebook-line" />
                </StyledTargerLink>
                <StyledTargerLink component="a" href="https://www.linkedin.com/company/plusvalica">
                  <Iconify icon="mdi:linkedin" />
                </StyledTargerLink>
                <StyledTargerLink component="a" href="https://www.instagram.com/plusvalica">
                  <Iconify icon="ri:instagram-fill" />
                </StyledTargerLink>
                <StyledTargerLink component="a" href="https://www.youtube.com/@plusvalica4093">
                  <Iconify icon="mdi:youtube" />
                </StyledTargerLink>
              </Stack> 
            </Stack>
          </LayoutContainer>
        </Stack>
        <Divider variant="fullWidth" orientation="horizontal" />
        <Stack py={3}>
          <LayoutContainer>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              maxWidth={{ xs: "100%", md: "85%" }}
              m="auto"
            >
              <Stack direction="row" alignItems="center" gap={2}>
                <Typography variant="subtitle1" color="text.secondary">
                  @2025 Plusvalica. Todos los Derechos Reservados.
                </Typography>
              </Stack>
              <Stack direction="row" alignItems="center" gap={2}>
                <Typography 
                  component="a"
                  target="_blank" 
                  rel="noopener noreferrer" 
                  sx={{ textDecoration: 'none' }} 
                  href="https://plusvalica.com/terminos-y-condiciones/?_gl=1*4hnvi1*_ga*ODQ2MzMzNjc4LjE3NjUzOTYxNTU.*_ga_CDXNNPEL3X*czE3NjU1Njg5MTQkbzQkZzAkdDE3NjU1Njg5MTQkajYwJGwwJGgw" variant="subtitle1" color="#a95052">
                  Términos y Condiciones
                </Typography>
              </Stack>
            </Stack>
          </LayoutContainer>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default AppFooter;

const FooterLink = [
  {
    id: 1,
    title: "Ecosistema",
    child: [
      {
        link: process.env.REACT_APP_REWARDS,
        title: "Plusval Rewards",
      },
      {
        link: process.env.REACT_APP_WALLET,
        title: "Plusval Wallet",
      },
    ],
  },
];
